import React from "react";

const SpaceUnLockedIcon = () => {
  return (
    <svg
      width="14"
      height="21"
      viewBox="0 0 14 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 12.0001H0V19.1204C0 20.0508 1.02915 21.0001 1.75665 21.0001H12.2079C13.2548 21.0001 14 20.1837 14 19.0824V12.0001Z"
        fill="#A6A6A6"
      />
      <path
        d="M11.5 11.0001V6.9119C11.5 0 2.5 0.5 2.5 6.91189V8.00011"
        stroke="#A6A6A6"
        strokeWidth="3"
      />
    </svg>
  );
};

export default SpaceUnLockedIcon;
